import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, WidthType } from 'docx';
import secondimage from '../../../../../../Assests/ReportImages/secondimage.png'
const heading2 = await fetch(secondimage).then(response => response.blob())

const secondimg = new ImageRun({
    type: 'png',
    data: await heading2.arrayBuffer(),
    transformation: { width: 150, height: 120 },
});

export const scopeImage = new Paragraph({
    indent: { left: 130 },
    // spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    spacing: { before: 400 },
    alignment: AlignmentType.LEFT,
    children: [secondimg]
})

export const scopeHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 150 },
    children: [
        new TextRun({
            text: "2. Scope",
            size: 40,
            color: "0189f9",
            font: "Gill Sans MT(Headings)",
            bold: true,
            italics: false
        })
    ], heading: HeadingLevel.HEADING_2,
})

export function scopeText(customerName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        indent: { left: 600, right: 800 },

        spacing: { before: 250, after: 300, line: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION performed Source Code audit on the below mentioned version of code provided by ${customerName}.`,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
        ],
    })
}

export const scopeTable = new Table({
    width: { size: 60, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 1200 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "#",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 200, right: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Application Name",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 200, right: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Repository Name",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 200, right: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Branch Name",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "CBE7FE" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "0189f9" },
                    },
                }),

            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "1.",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })]
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })]
                })
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "2.",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })]
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 80, after: 80 },
                            indent: { left: 100, right: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })]
                })
            ]
        }),


    ]
})